import React from "react";
import { Form, Button, Col } from "antd";
import FormInput from "../common/FormInput";

const CampaignForm = props => {
  const { getFieldDecorator, handleSubmit, Fields, value } = props;
  return (
    <Col style={{ textAlign: "center", margin: "100px 10%" }}>
      <h2>Create Project</h2>

      <Form
        layout="inline"
        onSubmit={handleSubmit}
        className="campaign-form"
        style={{ marginTop: 40 }}
      >
        {Fields &&
          Fields.map((field, index) => (
            <FormInput
              value={value}
              key={index}
              field={field}
              getFieldDecorator={getFieldDecorator}
            />
          ))}
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            Build Your Campaign
          </Button>
        </Form.Item>
      </Form>
    </Col>
  );
};

export default CampaignForm;
